import { FC } from "react"
import clsx from "clsx"

import { useTranslation } from "react-i18next"

import { TopBar } from "components/navigation/TopBar"

import { GgrLimitHistoryPanel } from "features/ggr/ggr-history/GgrLimitHistoryPanel"
import { GgrLimitSection } from "features/ggr/GgrLimitSection"
import { GgrMonthlyReportDownload } from "features/ggr/GgrMonthlyReportDownload"

import { useProps } from "contexts/PropsContext"

export const GGRMonthlyReport: FC = () => {
  const { darkMode } = useProps()
  const { t } = useTranslation("translation", { useSuspense: false })

  return (
    <div className={clsx(darkMode && "dark")}>
      <div className="w-full max-w-[100vw] p-4 pt-0 sm:p-8 sm:pt-0">
        <TopBar title={t("pages.ggrReport.title")} />

        <div className="mt-4 rounded-xl border border-[rgba(0,0,0,0.05)] dark:border-[rgba(255,255,255,0.1)] bg-white dark:bg-[#0C0C1A] p-4">
          <GgrMonthlyReportDownload />

          <div className="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-4">
            <GgrLimitSection scope="CASINO" />
            <GgrLimitSection scope="SPORTSBOOK" />
          </div>

          <GgrLimitHistoryPanel />
        </div>
      </div>
    </div>
  )
}
